import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { Footer, Navbar, Seo, Spinner } from "./components";

export const Layout = () => {
  return (
    <Suspense
      fallback={
        <div className="h-[50vh] flex justify-center items-center">
          <Spinner />
        </div>
      }>
      <Navbar />
      <Seo />
      <ScrollRestoration />
      <Outlet />
      <Footer />
    </Suspense>
  );
};

export const NoMatch = () => {
  return (
    <div className="h-96 content-center text-center pt-20">
      <h2 className="text-3xl font-bold">Nothing to see here!</h2>
      <p className="mt-4">
        Go to{" "}
        <a href="/" className="text-blue-500 underline">
          Home
        </a>
      </p>
    </div>
  );
};
